// extracted by mini-css-extract-plugin
export var copy = "LogosHeader-module--copy--b3913";
export var evergreen = "LogosHeader-module--evergreen--23101";
export var fadeIn = "LogosHeader-module--fadeIn--a783e";
export var headingSuper = "LogosHeader-module--heading-super--8e423";
export var image = "LogosHeader-module--image--e23c8";
export var logo = "LogosHeader-module--logo--81d56";
export var logos = "LogosHeader-module--logos--59e0e";
export var logosHeader = "LogosHeader-module--logos-header--dfce0";
export var slideDown = "LogosHeader-module--slideDown--bae0a";